<div id="video-selection-overlay" data-cy="video-selection-panel">
  <div class="flex-row justify-content-center">
    <button
      mat-icon-button
      class="btn btn-flat-primary"
      (click)="closePanel.emit()"
    >
      <i class="ri-arrow-down-s-line"></i>
    </button>
  </div>

  <div class="flex-column video-selection-list">
    <div
      class="video-selection-list__source"
      *ngFor="let source of sources; let sourceIndex = index"
      (click)="select(sourceIndex)"
      [class.selected]="sourceIndex === selectedIndex"
    >
      <img [src]="source.thumbnail | preprocess | async" alt="" />
      <!-- <div>Video {{ videoIndex + 1 }}</div> -->
    </div>
  </div>
</div>
